__turbopack_context__.v({
  "bannerTitle": "b9anGa_bannerTitle",
  "bannerWrapper": "b9anGa_bannerWrapper",
});
